var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "136 -824 688 688",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.13-136q-70.67 0-133.41-26.84-62.73-26.84-109.86-73.92t-73.99-109.76Q136-409.19 136-479.87q0-71.67 26.84-133.91 26.84-62.23 73.92-109.36t109.76-73.99Q409.19-824 479.87-824q71.67 0 133.91 26.84 62.23 26.84 109.36 73.92t73.99 109.26Q824-551.81 824-480.13q0 70.67-26.84 133.41-26.84 62.73-73.92 109.86t-109.26 73.99Q551.81-136 480.13-136m-.13-32q59.59 0 112.83-21.08 53.25-21.07 95.55-59.23L248.31-688.38q-37.39 42.3-58.85 95.55Q168-539.59 168-480q0 130 91 221t221 91m231.69-103.62q38.16-42.3 59.23-95.55Q792-420.41 792-480q0-130-91-221t-221-91q-59.86 0-113.35 20.69-53.5 20.69-95.03 59.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.ec2b11271147a0891383b822dfce525e.svg";
export { ForwardRef as ReactComponent };